import { Package, CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useCompletePaymentMethodChange } from "@/features/payment-methods";
import { AppRoute } from "@/types/routes";

export const PhysicalCardSuccessPage = () => {
  const { t } = useTranslation();
  const { completeOrNavigate } = useCompletePaymentMethodChange();

  // Ordered on a Claim Detour: the shipping steps have been read, so finish the
  // change and hand them back to the claim they were starting. Otherwise, home.
  const handleDone = () => completeOrNavigate(AppRoute.HOME);

  return (
    <Card className="w-full">
      <CardHeader>
        <div className="flex items-center gap-4">
          <div className="flex justify-center">
            <div className="relative">
              <div className="rounded-full bg-green-100 p-4">
                <Package className="size-5 text-green-600" />
              </div>
              <div className="absolute -bottom-1 -right-1 rounded-full bg-white p-1">
                <CheckCircle2 className="size-4 text-green-600" />
              </div>
            </div>
          </div>
          <div>
            <CardTitle className="text-xl">
              {t("physicalCard_success_title")}
            </CardTitle>
            <CardDescription className="mt-1">
              {t("physicalCard_success_description")}
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="rounded-lg text-sm p-4 space-y-2">
          <p className="font-medium">{t("physicalCard_success_next_steps")}</p>
          <ul className="space-y-1 text-muted-foreground">
            <li>• {t("physicalCard_success_step_1")}</li>
            <li>• {t("physicalCard_success_step_2")}</li>
            <li>• {t("physicalCard_success_step_3")}</li>
          </ul>
        </div>

        <Button className="w-full" size="lg" onClick={handleDone}>
          {t("done")}
        </Button>
      </CardContent>
    </Card>
  );
};
